export default __webpack_public_path__ + "static/media/345.46b25c61.png";